export default __webpack_public_path__ + "splash-02.4542f.svg";